import i18n from 'i18next'
import {initReactI18next} from 'react-i18next'
import translationsHu from './locales/hu/translations.json'
import translationsEn from './locales/en/translations.json'
import {
  availableLanguages,
  AvailableLanguageType,
} from '../utils/helpers/currentLang'
import {Config} from '../constants/Config'

export const initI18n = (lang: AvailableLanguageType | undefined) => {
  i18n.use(initReactI18next).init({
    fallbackLng: Config.defaultLanguage,
    lng: lang,
    resources: {
      hu: {
        translations: translationsHu,
      },
      en: {
        translations: translationsEn,
      },
    },
    ns: ['translations'],
    defaultNS: 'translations',
    interpolation: {
      escapeValue: false,
    },
  })

  i18n.languages = availableLanguages
}
